import useGetUserProfileService from '@main-hooks/useGetUserProfileService';
import { UseApiCallProps } from '@pages/lending/types';
import { selectProfileData } from '@pages/profile/store/selectors';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useApiCall } from 'use-api-call';
import updateTermsServcice from '../api/updateTerms.service';
import type {
  UpdateTermsService,
  UpdateTermsServiceResponse,
  UseRequestTermsService,
} from '../types';

const useRequestTermsService = (): UseRequestTermsService => {
  const userProfile = useSelector(selectProfileData);
  const enterpriseId = userProfile?.company.enterpriseId || '0';
  const { acceptedTerms } = userProfile || {};

  const { loadingUserProfile, profileInformation, getUserProfile } =
    useGetUserProfileService();

  const {
    loading,
    data: termsData,
    invoke: updateTermsByUser,
  }: UseApiCallProps<
    UpdateTermsServiceResponse,
    UpdateTermsService['data']
  > = useApiCall((data: UpdateTermsService['data']) =>
    updateTermsServcice.updateTermsByUser({
      enterpriseId,
      data,
    })
  );

  const { naturalPerson } = userProfile || {};
  const { name, lastName } = naturalPerson || {};

  const [termsAccepted, setTermsAccepted] = useState(false);

  const openTermsByCountry = () => {
    window.open('https://legal.efexpay.com/', '_blank');
  };

  useEffect(() => {
    if (termsData && termsData.status === 204 && !loading) {
      getUserProfile();
    }
  }, [termsData, loading, getUserProfile]);

  useEffect(() => {
    if (profileInformation && profileInformation.acceptedTerms) {
      window.location.reload();
    }
  }, [loadingUserProfile, profileInformation]);

  return {
    acceptedTerms: !!acceptedTerms,
    name,
    lastName,
    termsAccepted,
    openTermsByCountry,
    setTermsAccepted,
    updateTermsByUser,
  };
};

export default useRequestTermsService;
